module.exports = __webpack_public_path__ + "assets/icon-pref-selected.eba257ab.svg";